/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetRadialIcon16Solid = forwardRef('TargetRadialIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 9.375a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 8.004a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0ZM8 5.504a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.875 8.004a7.125 7.125 0 1 1 14.25 0 7.125 7.125 0 0 1-14.25 0ZM8 2.63a5.375 5.375 0 1 0 0 10.75A5.375 5.375 0 0 0 8 2.63Z" })));
});
